/*办公费用 */
import { $http, buildHeaders } from "./index";

//获取列表
export const officeExpenseApply_page = (params) => {
  return $http.get("/admin/OfficeExpenseApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const officeExpenseApply_detail = (id) => {
  return $http.get("/admin/OfficeExpenseApply/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const officeExpenseApply_search = (id) => {
  return $http.get("/admin/OfficeExpenseApply/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const officeExpenseApply_add = (data) => {
  return $http.post("/admin/OfficeExpenseApply/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const officeExpenseApply_edit = (data) => {
  return $http.post("/admin/OfficeExpenseApply/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消
export const officeExpenseApply_cancel = (data) => {
  return $http.post("/admin/OfficeExpenseApply/cancel", data, {
    headers: buildHeaders(3, "正在删除数据，请稍后……"),
  });
};

//删除
export const officeExpenseApply_delete = (id) => {
  return $http.post(
    "/admin/OfficeExpenseApply/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};


//获取列表
export const officeExpenseApprove_page = (params) => {
  return $http.get("/admin/OfficeExpenseApprove/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const officeExpenseApprove_detail = (id) => {
  return $http.get("/admin/OfficeExpenseApprove/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const officeExpenseApprove_search = (id) => {
  return $http.get("/admin/OfficeExpenseApprove/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};


//审批
export const officeExpenseApprove_approve = (data) => {
  return $http.post("/admin/OfficeExpenseApprove/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
